import closeIcon from "@loot-os/icons/icons/close";
import replyIcon from "@loot-os/icons/icons/reply";
import { Icon } from "../../core/Icon.js";
import { IconButton } from "../../core/IconButton.js";
import { cn } from "../../foundations/cn.js";

export interface ChatReplyBarProps {
  /** "Replying to". */
  label: string;
  name: string;
  /** The message being answered, cut to one line. */
  text: string;
  cancelLabel: string;
  onCancel: () => void;
  className?: string;
}

/** Above the composer while answering a message: who and what, and a way out. */
export function ChatReplyBar({
  label,
  name,
  text,
  cancelLabel,
  onCancel,
  className,
}: ChatReplyBarProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 border-t border-border-subtle bg-bg-raised px-3 py-1.5 font-body text-body-b3 text-text-secondary",
        className,
      )}
    >
      <Icon icon={replyIcon} size={14} className="shrink-0 text-accent-text" />
      <p className="min-w-0 flex-1 truncate">
        {label} <span className="font-medium text-text-primary">{name}</span>
        <span className="text-text-tertiary"> · {text}</span>
      </p>
      <IconButton
        icon={closeIcon}
        label={cancelLabel}
        variant="ghost"
        size="sm"
        onClick={onCancel}
      />
    </div>
  );
}
